import { Pipe, PipeTransform } from '@angular/core';
import { getCategoryDisplayLabel } from './category-ordering.helper';

@Pipe({
  name: 'categoryDisplayLabel',
  standalone: true,
})
export class CategoryDisplayLabelPipe implements PipeTransform {
  transform(category: any): string {
    return getCategoryDisplayLabel(category);
  }
}
